import React, { useRef } from "react";
import { AccountInformationData } from "./AccountInformation.data";
import FormCreator from "../../../../components/Forms/FormCreator";
import Accordion from "../../../../components/Accordion/Accordion";

const AccountInformationForm = () => {
  const accountInformationRef = useRef();
  const [ formData, setFormData ] = React.useState( AccountInformationData );
    
  return (
      <Accordion title="Account Information" button={false} accordion={false}>
        <div className="row">
          <FormCreator
            ref={accountInformationRef}
            {...formData}
          />
        </div>
      </Accordion>
  );
};
export default AccountInformationForm;
